module.exports = __webpack_public_path__ + "static/fonts/Helvetica-Neue-2.84ec4bea.ttf";